import { combineReducers } from 'redux'
import { reducer as notifications } from '../modules/notification'
import locationReducer from './location'
import iconstore from './iconStoreReducer'
import localstore from './localStoreReducer'
import catstore from './categoryReducer'
import icoSettings from './settingsReducer'
import globalDataReducer from './globalDataReducer'
import iconDetail from './iconDetailReducer'

export const makeRootReducer = asyncReducers => {
	return combineReducers({
		// Add sync reducers here
		icoSettings,
		iconstore,
		iconDetail,
		localstore,
		catstore,
		notifications,
		globalData: globalDataReducer,
		location: locationReducer,
		...asyncReducers
	})
}

export const injectReducer = (store, { key, reducer }) => {
	store.asyncReducers[key] = reducer
	store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
